import type { SupportedLanguage } from '@/i18n/language'
import { Route as RootRoute } from '@/routes/__root'
import { useCurrentUserQuery } from '@/graphql/queries/currentUserQuery.gql.generated'
import { decorateCurrentUserPermissions } from '@/shared/lib/workspace-permissions'
import { resolveLanguage } from '@/i18n/language'

export function useCurrentUserProfile() {
  const { currentUser: initialCurrentUser } = RootRoute.useRouteContext()
  const query = useCurrentUserQuery({
    fetchPolicy: 'cache-and-network',
  })
  const currentUser = decorateCurrentUserPermissions(
    query.data?.currentUser ?? initialCurrentUser,
  )

  const preferredLanguage: SupportedLanguage = resolveLanguage({
    apiLanguage: currentUser?.preferredLanguage ?? null,
    browserLocale: typeof navigator !== 'undefined' ? navigator.language : 'en',
  })

  return {
    ...query,
    currentUser,
    preferredLanguage,
  }
}
